class Tabs {
  constructor(node) {
    this.wrapper = node;
    this.router = new Navigo(null, true);
    this.router
      .on(':id', ({ id }) => {
        id = id.replace('#', '');
        this.showTab(id);
      })
      .resolve();
  }

  showTab(id) {
    const matchedNodes = Array.from(
      this.wrapper.querySelectorAll(`.js-tabs-content[data-id='${id}']`)
    );
    if (!matchedNodes) {
      return;
    }
    this.updateNav(id);
    const otherNodes = Array.from(
      this.wrapper.querySelectorAll(`.js-tabs-content:not([data-id='${id}'])`)
    );
    otherNodes.forEach(node => node.classList.add('tabs--hidden'));
    matchedNodes.forEach(node => node.classList.remove('tabs--hidden'));
  }

  updateNav(id) {
    const matchedNodes = Array.from(
      this.wrapper.querySelectorAll(`.js-tabs-link[href='#${id}']`)
    );
    const otherNodes = Array.from(
      this.wrapper.querySelectorAll(`.js-tabs-link:not([href='#${id}'])`)
    );
    matchedNodes.forEach(node => node.classList.add('tabs__link--selected'));
    otherNodes.forEach(node => node.classList.remove('tabs__link--selected'));
  }
}

export default () => {
  const tabsNodes = Array.from(document.querySelectorAll('.js-tabs'));

  if (!tabsNodes.length) {
    return;
  }

  tabsNodes.forEach(node => (window.tabs = new Tabs(node)));
};



// WEBPACK FOOTER //
// ./assets/scripts/components/tabs.js